module.exports = __webpack_public_path__ + "static/Photo_0001-5b10e6309f4c80ca8e78eb0a02d53d9f.jpg";